module.exports = __webpack_public_path__ + "img/scaleplus-logo.fe776763.png";